import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-teddy-primary via-white to-teddy-secondary"></div>
      
      {/* Floating Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <motion.div
          className="absolute top-20 left-10 w-72 h-72 bg-[rgba(165,124,69,0.4)] rounded-full mix-blend-multiply filter blur-xl opacity-70"
          animate={{
            x: [0, 100, 0],
            scale: [1, 1.2, 1],
          }}
          transition={{
            duration: 3,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
        <motion.div
          className="absolute top-40 right-10 w-96 h-96 bg-[rgba(165,124,69,0.7)] rounded-full mix-blend-multiply filter blur-xl opacity-70"
          animate={{
            x: [0, -150, 0],
            scale: [1.2, 1, 1.2],
          }}
          transition={{
            duration: 10,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
        <motion.div
          className="absolute bottom-20 left-1/4 w-80 h-80 bg-[rgba(165,124,69,1)] rounded-full mix-blend-multiply filter blur-xl opacity-70"
          animate={{
            x: [0, 120, 0],
            scale: [1, 1.3, 1],
          }}
          transition={{
            duration: 7,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
      </div>

      {/* Content */}
      <div className="container-custom relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto"
        >
          {/* Main Slogan */}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="hero-title font-bold text-teddy-text mb-6 drop-shadow-lg"
          >
            <span className="text-shadow-lg">언제나 고객과 브랜드 옆,</span>
            <br />
            <span className="text-gradient drop-shadow-[0_4px_8px_rgba(0,0,0,0.2)]">가장 가까운 자리에서</span>
            <br />
            <span className="text-shadow-xl">함께하는 팀 TEDDY</span>
          </motion.h1>

          {/* Subtitle */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="hero-subtitle text-teddy-muted mb-8 max-w-3xl mx-auto"
          >
            당신의 브랜드 곁을 늘 지키며 브랜드의 가치를 함께 빛내고
            <br />
            믿을 수 있는 파트너 테디 에이전시입니다.
          </motion.p>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="hero-buttons"
          >
            <Link
              to="/portfolio"
              className="btn-primary hero-button"
            >
              포트폴리오 보기
            </Link>
            <Link
              to="/contact"
              className="btn-secondary hero-button"
            >
              문의하기
            </Link>
          </motion.div>

          {/* Scroll Indicator */}
          {/* <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 1 }}
            className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
          >
            <motion.div
              animate={{ y: [0, 10, 0] }}
              transition={{ duration: 2, repeat: Infinity }}
              className="w-6 h-10 border-2 border-teddy-muted rounded-full flex justify-center"
            >
              <motion.div
                animate={{ y: [0, 12, 0] }}
                transition={{ duration: 2, repeat: Infinity }}
                className="w-1 h-3 bg-teddy-muted rounded-full mt-2"
              />
            </motion.div>
          </motion.div> */}
        </motion.div>
      </div>
    </section>
  )
}

export default HeroSection 